import {
  QueryClient,
  QueryClientProvider as ReactQueryClientProvider,
} from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  },
});

function QueryClientProvider({
  children,
  ...props
}: {
  children: React.ReactNode;
}) {
  return (
    <ReactQueryClientProvider client={queryClient} {...props}>
      {children}
    </ReactQueryClientProvider>
  );
}

export { QueryClientProvider };
